<template>
  <div>
    <a-row v-for="(item,index) in list" :gutter="10">
      <a-col :md="5" :sm="24">
        <a-select
          showSearch
          :filterOption="filterOption"
          v-model="item.fieldId"
          placeholder=""
          @change="value => changeField(value, item)"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          :defaultActiveFirstOption="false">
          <a-select-option v-for="(item, index) in fieldList" :key="index" :value="item.id" :disabled="item.disabled">
            {{ item.name }} / {{ item.id }}
          </a-select-option>
        </a-select>
      </a-col>
      <a-col :md="2" :sm="24">
        <a-select v-model="item.requiredState" placeholder="" :defaultActiveFirstOption="false">
          <a-select-option v-for="(item, index) in requiredList" :key="index" :value="item.id">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-col>
      <a-col :md="2" :sm="24">
        <a-select v-model="item.status" placeholder="" disabled>
          <a-select-option v-for="(item, index) in parameterStatus" :key="index" :value="item.id">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-col>
      <a-col :md="15" :sm="24">
        <a-col :md="3">
          <a-select v-model="item.valueType" placeholder="" @change="changeValueType(item)" disabled>
            <a-select-option v-for="(item, index) in typeList" :key="index" :value="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :md="21" class="inputDel">
          <a-input v-model="item.valueOptions" disabled/>
          <a-icon type="close-square" theme="filled"  style="color: red;font-size: 20px" @click="del(index)"/>
        </a-col>
      </a-col>
    </a-row>
    <a-row class="add-btn">
      <a-col :md="24">
        <a-button type="dashed" style="width:100%" @click="add" block>
          <a-icon type="plus" />添加
        </a-button>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { checkFieldDelete } from '@/api/deviceParameter'
import { delFieldCheck } from '@/api/fieldManage'
import { mapGetters } from 'vuex'

export default {
  name: 'OtherData',
  props: ['list', 'originalList', 'delList', 'fieldList'],
  data () {
    return {
      requiredList: [
        {
          id: 1,
          name: '是'
        },
        {
          id: 0,
          name: '否'
        }
      ],
      parameterStatus: [
        {
          id: 1,
          name: '启用'
        },
        {
          id: 2,
          name: '禁用'
        }
      ],
      // 填写类型
      typeList: [
        {
          id: 1,
          name: '填空'
        },
        {
          id: 2,
          name: '单选'
        },
        {
          id: 3,
          name: '日期'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['typeCode'])
  },
  methods: {
    // 改变填写类型
    changeValueType (item) {
      item.valueOptions = ''
    },
    // 改变参数状态 (禁用)
    changeStatus (value, item) {
      if (item.id) {
        const params = {
          dataIndex: item.id,
          type: 2
        }
        checkFieldDelete(params).then(res => {
          if (res.status === 0) {
            if (res.data) {
              this.$message.error('该字段已被使用，无法修改状态')
              const index = this.originalList.findIndex(item2 => item2.id === item.id)
              item.status = this.originalList[index].status
            }
          } else {
            this.$message.error(res.info.message)
          }
        }).catch(err => {
          this.$message.error(err.info.message)
        })
      }
    },
    // 改变字段
    changeField (value, item) {
      if (item.state === 2) {
        const index = this.originalList.findIndex(item2 => item2.id === item.id)
        const data = JSON.parse(JSON.stringify(this.originalList[index]))
        const params = {
          id: data.fieldId,
          typeCode: this.typeCode.code
        }
        delFieldCheck(params).then(res => {
          if (res.status === 0) {
            if (res.data.state === 'SUCCESS') {
              const functionData = {
                index,
                data,
                value,
                item,
                type: 'select'
              }
              this.tip(res.data.msg, functionData)
            } else {
              item.fieldId = data.fieldId
              this.$emit('resetFieldDisabled')
              this.$message.error(res.data.msg)
            }
          } else {
            this.$message.error(res.info.message)
          }
        })
          .catch(err => {
            this.$message.error(err.info.message)
          })
      } else {
        const fieldIndex = this.fieldList.findIndex(item2 => item2.id === value)
        const fieldData = this.fieldList[fieldIndex]
        item.name = fieldData.name
        item.status = fieldData.status
        item.valueType = fieldData.valueType
        item.valueOptions = fieldData.valueOptions
        item.state = 1
        this.$emit('resetFieldDisabled')
      }
    },
    // 重置field的disabled
    resetFieldDisabled () {
      this.fieldList.forEach(i => {
        i.disabled = i.status === 2
      })
      this.list.forEach(i => {
        const index = this.fieldList.findIndex(item2 => item2.id === i.fieldId)
        this.fieldList[index].disabled = true
      })
    },
    add () {
      this.list.push(
        {
          'fieldId': undefined,
          'name': '',
          'requiredState': 0,
          'basicState': false,
          'status': undefined,
          'valueType': undefined,
          'valueOptions': '',
          'state': 1
        })
      this.originalList.push(
        {
          'fieldId': undefined,
          'name': '',
          'requiredState': 0,
          'basicState': false,
          'status': undefined,
          'valueType': undefined,
          'valueOptions': '',
          'state': 1
        })
    },
    del (index) {
      const data = { ...this.list[index] }
      const that = this
      if (data.fieldId && data.state === 2) {
        const params = {
          id: data.fieldId,
          typeCode: this.typeCode.code
        }
        delFieldCheck(params).then(res => {
          if (res.status === 0) {
            if (res.data.state === 'SUCCESS') {
              const functionData = {
                index: index,
                data: data,
                type: 'del'
              }
              this.tip(res.data.msg, functionData)
            } else {
              this.$message.error(res.data.msg)
            }
          } else {
            this.$message.error(res.info.message)
          }
        })
          .catch(err => {
            this.$message.error(err.info.message)
          })
      } else {
        that.list.splice(index, 1)
        that.originalList.splice(index, 1)
        that.$emit('resetFieldDisabled')
      }
    },
    // 提示
    tip (title, params) {
      const that = this
      that.$confirm({
        title: (h) => {
          return h('div', {
            domProps: {
              innerHTML: title
            }
          })
        },
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        width: 520,
        onOk () {
          if (params.type === 'del') {
            params.data.status = 9
            params.data.state = 9
            that.delList.push(params.data)
            that.list.splice(params.index, 1)
            that.originalList.splice(params.index, 1)
            that.$emit('resetFieldDisabled')
          } else {
            params.data.status = 9
            params.data.state = 9
            that.delList.push(params.data)
            that.originalList.splice(params.index, 1)
            const fieldIndex = that.fieldList.findIndex(item2 => item2.id === params.value)
            const fieldData = that.fieldList[fieldIndex]
            params.item.id = fieldData.id
            params.item.name = fieldData.name
            params.item.status = fieldData.status
            params.item.valueType = fieldData.valueType
            params.item.valueOptions = fieldData.valueOptions
            params.item.state = 1
            that.$emit('resetFieldDisabled')
          }
        },
        onCancel () {
          if (params.type === 'select') {
            params.item.fieldId = params.data.fieldId
            that.$emit('resetFieldDisabled')
          }
        }
      })
    },
    // 搜索
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
  }
}
</script>

<style lang="less" scoped>
.inputDel {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .ant-input {
    width: calc(100% - 28px);
  }
}
/deep/.ant-select {
  width: 100%;
}
/deep/.ant-col-md-5 {
  width: 20% !important;
  margin-bottom: 12px;
}
/deep/.ant-col-md-9 {
  width: 40% !important;
  margin-bottom: 12px;
}
.add-btn {
  position: sticky;
  bottom: 0;
  right: 0;
  left: 0;
  margin: auto;
  .anticon{
    color: #1791FF;
  }
}
/deep/.ant-select-dropdown-menu-item-disabled {
  color: rgb(191, 191, 191);
}
</style>
